import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component }  from 'react';
import {Tab, Row, Col} from "react-bootstrap";
import {sleep} from "./AddBrandModal"
import { apiFetch, API, getMarket } from "../../services/api";

export default class AddMerchandModalForm extends Component {
    constructor(props) {
        super(props);
        this.state ={
            imgToDisplay: null,
            selectedLogo: this.props.selectedMerchand.s3LogoUrl
        };

    }

    uploadImg = async (e) => {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "merchants/"+fileName
                })
            }).then((res) =>
                res.json().then( result =>{
                        sleep(2000)
                        this.props.selectedMerchand.s3LogoUrl = result.message
                        this.setState({selectedLogo: result.message})
                    }
                )
            )
                .catch( err =>
                    console.log(err)
                );
        }
    }

    handleClose = () => {
        this.props.selectedMerchand.language = getMarket()
        return apiFetch(API.products + '/merchant', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.props.selectedMerchand)
    })
        .then( () => (
            this.props.closeModal, window.location.reload(false)
            ))
        .catch( err =>
            console.log(err)
        );
    };

    render(){
        this.props.selectedMerchand.enable = true
        return(
            <Modal
                show={this.props.isOpen}
                onHide={this.props.closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter un site marchand</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Row>
                            <Col>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Form.Group >
                                            <Form.Label>Nom : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedMerchand.name = e.target.value} defaultValue={this.props.selectedMerchand.name} placeholder="Ex : Top4Running"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Logo : </Form.Label>
                                            <Form.File
                                                id="custom-file-translate-html"
                                                label="Ajouter un image"
                                                data-browse="Ajouter"
                                                onChange= {(e) => this.uploadImg(e)}
                                                custom
                                            />
                                            <img className="imgToDisplay" alt="Logo..." src={this.state.selectedLogo}/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Frais de port : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedMerchand.shippingPrice = e.target.value} defaultValue={this.props.selectedMerchand.shippingPrice} placeholder="Ex : Gratuit à partir de 90e"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Temps de livraison : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedMerchand.deliveryTime = e.target.value} defaultValue={this.props.selectedMerchand.deliveryTime} placeholder="Ex : 2 à 3 jours"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Délais de retour : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedMerchand.returningTime = e.target.value} defaultValue={this.props.selectedMerchand.returningTime} placeholder="Ex : 30 jours"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>URL affiliée : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedMerchand.url = e.target.value} defaultValue={this.props.selectedMerchand.url} placeholder="Ex : https://top4running.fr/?a_box=55zm62fc"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Affil_id : (uniquement pour les partenaires ne demandant pas de générer des deeplinks) </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedMerchand.affilID = e.target.value} defaultValue={this.props.selectedMerchand.affilID} placeholder="Ex : ?a_box=55zm62fc"/>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Notation : </Form.Label>
                                            <Form.Control
                                                as="select"
                                                onChange={(e) => this.props.selectedMerchand.rate = e.target.value }
                                                defaultValue={this.props.selectedMerchand.rate}
                                            >
                                                <option key="0" value="0">0</option>
                                                <option key="1" value="1">1</option>
                                                <option key="2" value="2">2</option>
                                                <option key="3" value="3">3</option>
                                                <option key="4" value="4">4</option>
                                                <option key="5" value="5">5</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Langues</Form.Label>
                                            <Form.Control
                                                as="select"
                                                multiple
                                                onChange={(e) => this.props.selectedMerchand.availableLanguages = [...e.target.selectedOptions].map(o => o.value)}
                                                defaultValue={this.props.selectedMerchand.availableLanguages}
                                            >
                                                {(this.props.languages) ? this.props.languages.map(language =>
                                                    <option key={language.name} value={language.name}>{language.name}</option>
                                                ) : <option>Aucune langue disponible</option>}
                                            </Form.Control>
                                        </Form.Group>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" type="cancel" onClick={this.props.closeModal}>
                        Annuler
                    </Button>
                    <Button variant="primary" type="submit" onClick={this.handleClose}>
                        Valider
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}